module.exports = __webpack_public_path__ + "static/media/hackerrank.7d39803b.svg";